export var DefinitionPoolTypeInfoKeyEnum;
(function (DefinitionPoolTypeInfoKeyEnum) {
    DefinitionPoolTypeInfoKeyEnum["DEFINITION_LOOKUP"] = "definitionLookup";
    DefinitionPoolTypeInfoKeyEnum["ACCESS_TYPE_LOOKUP"] = "accessTypeLookup";
})(DefinitionPoolTypeInfoKeyEnum || (DefinitionPoolTypeInfoKeyEnum = {}));
